
import { store }           from 'index';
import { SET_DRAGGED_BOX } from 'actions';

const handleDragStart = (event: any) => {

    const id = event.active.id;

    if ( id === 'draggableModal' ) {
        return
    }
    
    store.dispatch(SET_DRAGGED_BOX(+id))
}

export default handleDragStart